module.exports = "https://la-static.vkplay.ru/promo/universal/img/no-presents.f045610f.jpg";